import { useTranslation } from "react-i18next";
import { ViewHeader } from "../../../../components/view-header/ViewHeader";

import {
  Button,
  ButtonVariant,
  PageSection,
  ToolbarItem,
} from "@patternfly/react-core";
import {
  KeycloakDataTable,
  Action,
} from "@keycloak/keycloak-ui-shared";
import { IRowData, TableText, cellWidth } from "@patternfly/react-table";
import { emptyFormatter } from "../../../../util";
import type ClientRepresentation from "@keycloak/keycloak-admin-client/lib/defs/clientRepresentation";

import { Link, useNavigate } from "react-router-dom";

import useLdap from "./useLdap";

import { useConfirmDialog } from "../../../../components/confirm-dialog/ConfirmDialog";

const ToolbarItems = () => {
  const { t } = useTranslation();

  return (
    <ToolbarItem>
      <Button component={(props) => <Link {...props} to={"create"} />}>
        {t("point-createLdapConnections")}
      </Button>
    </ToolbarItem>
  );
};

const TextCell = (value: string) => {
  return (
    <TableText wrapModifier="truncate">
      {emptyFormatter()(value) as string}
    </TableText>
  );
};

export default function Ldap() {
  const { deleteId, tableData, handleDeleteLdap, handleAreYouSureDelete } =
    useLdap();

  const [toggleDeleteDialog, DeleteConfirm] = useConfirmDialog({
    titleKey: "Are you sure?",
    messageKey: "After delete there is no way to retrieve value",
    continueButtonLabel: "common:delete",
    continueButtonVariant: ButtonVariant.danger,
    onConfirm: () => handleDeleteLdap(deleteId),
  });

  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <ViewHeader titleKey={t("point-ldapConnections")} divider />

      <PageSection variant="light" className="pf-u-mr-sm">
        <ToolbarItems />
        <DeleteConfirm />
        <KeycloakDataTable
          loader={tableData}
          ariaLabelKey="ldaps:ldap"
          searchPlaceholderKey="clients:searchForClient"
          actionResolver={(rowData: IRowData) => {
            console.log(rowData);
            const actions: Action<ClientRepresentation>[] = [
              {
                title: t("edit"),
                onClick() {
                  const id = rowData.data.id;
                  navigate(id);
                },
              },
              {
                title: t("delete"),
                onClick() {
                  const id = rowData.data.id;
                  handleAreYouSureDelete(id);
                  toggleDeleteDialog();
                },
              },
            ];

            return actions;
          }}
          columns={[
            {
              name: "name",
              displayKey: "point-ldapName",
              transforms: [cellWidth(20)],
              cellRenderer: (row) => TextCell(row.name),
            },
            {
              name: "ldapHost",
              displayKey: "point-ldapHost",
              transforms: [cellWidth(20)],
              cellRenderer: (row) => TextCell(row.ldapHost),
            },
          ]}
        />
      </PageSection>
    </>
  );
}
